/**
 * HTTP timeouts for CSRP SPA → API (dev + production).
 * Override via .env at build time (CRA bakes env into the bundle).
 *
 * REACT_APP_API_REQUEST_TIMEOUT_MS       — normal GET/POST (default 3 min)
 * REACT_APP_API_LONG_RUNNING_TIMEOUT_MS — print PDF, heavy reports (default 1 h)
 * REACT_APP_API_UPLOAD_TIMEOUT_MS        — file uploads (default 1 h)
 */

const parsePositiveMs = (raw, fallback) => {
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : fallback;
};

/** Standard API calls (lists, detail header, dashboards). Fail fast — do not hold UI/SQL. */
export const API_REQUEST_TIMEOUT_MS = parsePositiveMs(
  process.env.REACT_APP_API_REQUEST_TIMEOUT_MS,
  90_000
);

/** Large downloads / print PDF / very heavy reports. */
export const API_LONG_RUNNING_TIMEOUT_MS = parsePositiveMs(
  process.env.REACT_APP_API_LONG_RUNNING_TIMEOUT_MS,
  60 * 60 * 1000
);

/** Multipart uploads. */
export const API_UPLOAD_TIMEOUT_MS = parsePositiveMs(
  process.env.REACT_APP_API_UPLOAD_TIMEOUT_MS,
  60 * 60 * 1000
);

/** Health probe (fast fail). */
export const API_HEALTH_TIMEOUT_MS = parsePositiveMs(
  process.env.REACT_APP_API_HEALTH_TIMEOUT_MS,
  15_000
);
